module.exports = __webpack_public_path__ + "img/11-2@2x.3a2f074f.jpg";